import {PageRequest} from "../../../models/api/PageRequest";
import {SortedRequest} from "../../../models/api/SortedRequest";
import {HttpClient} from "../../_http/HttpClient";
import Page from "../../../models/api/Page";
import {Api} from "../../Api";
import {Device} from "../../device/DeviceApi";
import FailureReport from "../../failure/report/FailureReport";

export type CalendarEvent = {
    id: string;
    unit: string;
    comment: string;
    date: [number, number, number];
    endDate: [number, number, number] | null;
    devices: Device[];
    addPrefixAutomatically: boolean;
    failureReport: FailureReport | null;
}

export type SearchQueryBase = {
    q?: string;
    unit?: string;

    /**
     * yyyy-MM-dd
     */
    fromDate?: string;

    /**
     * yyyy-MM-dd
     */
    toDate?: string;
}

export type SearchQuery = SearchQueryBase & PageRequest & SortedRequest;

export type Action = {
    selectedElements: string[];
    action: 'delete';
}

export type CreatePayload = {
    unit: string;
    date: string;
    comment: string;
    endDate?: string | null;
    addPrefixAutomatically?: boolean | undefined | null;
    createFailureReport?: boolean | undefined | null;
    relatedDeviceNumber?: string | null;
}

export type UpdatePayload = CreatePayload;

class CalendarEventApi {
    static search(query: SearchQuery) {
        const url = Api.getUrl('/calendar/event');
        return HttpClient.get<Page<CalendarEvent>>(url, { ...query });
    }

    static performAction(action: Action) {
        const url = Api.getUrl('/calendar/event/action');
        return HttpClient.postAndExpectNoContent(url, {}, { ...action});
    }

    static create(payload: CreatePayload) {
        const url = Api.getUrl('/calendar/event/create');
        return HttpClient.post<CalendarEvent>(url, {}, { ...payload });
    }

    static updateById(id: string, payload: UpdatePayload) {
        const url = Api.getUrl(`/calendar/event/${id}`);
        return HttpClient.put<CalendarEvent>(url, {}, { ...payload });
    }

    static getById(id: string) {
        const url = Api.getUrl(`/calendar/event/${id}`);
        return HttpClient.get<CalendarEvent>(url, { id });
    }
}

export default CalendarEventApi;